import Vue from "vue";
import Vuex from 'vuex';

import {collegeStorage} from "./college-storage";
import {security} from "./security";

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        security: security,
        collegeStorage
    }
});
